import {
  DeepRequired,
  FieldErrorsImpl,
  FieldValues,
  UseFormRegister,
} from "react-hook-form";
import { useApiErrors } from "../../hooks";
import {
  IKeyValuePair,
  ISelectGroupedItemsProps,
  ISelectOptionProps,
  TCarbonComponentSizeProps,
} from "../../interfaces-and-types";
import { getApiErrorsByFieldName } from "../../utils";

import { View } from "./View";
import { IInfoIconProps } from "../InfoIcon/InfoIcon";
import { ReactNode } from "react";
// import { View } from "./View.ReactSelect";

export interface ISelectProps {
  name: string;
  title?: string;
  arrayFieldName?: string;
  arrayFieldIndex?: string;
  label: string;
  helperText?: string;
  infoIconText?: ReactNode;
  infoIconPosition?: IInfoIconProps["align"]; // infoIcon align
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  size?: TCarbonComponentSizeProps;
  defaultValue?: string;
  showSkeleton?: boolean;
  hideSkeletonLabel?: boolean;
  selectItems: ISelectOptionProps[];
  selectGroupedItems?: Array<ISelectGroupedItemsProps>;
  placeholder?: string;

  // error display
  invalid?: boolean;
  invalidText?: string;

  // controlled form props
  value?: string | number | null;
  onChange?: (value: any) => void;

  loadAsyncOptions?: (search: string) => ISelectOptionProps[];
}

export function Select(props: ISelectProps) {
  const { name, ...rest } = props;

  return <View name={name} {...rest} />;
}
